<div class="file-attachment-container">
  <!-- Progress bar for overall loading -->
  @if (loading) {
  <div class="loading-bar">
    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
  </div>
  }

  <!-- Info message -->
  <div class="info-message">
    <mat-icon>info</mat-icon>
    <span>{{'components.attachment.file-attachment.notify-max-size' | translate}} {{humanizeFileSize | number: '1.0-2'
      }}Mb</span>
  </div>

  <!-- Dropzone area -->
  <ngx-dropzone class="dropzone-container" [class.dragover]="dragOver" [class.has-files]="files.length > 0"
    (dragover)="onDragOver(true)" (dragleave)="onDragOver(false)" (drop)="onDragOver(false)">

    <input type="file" fileInput multiple [accept]="data?.acceptedTypes || '*/*'"
      (selectionChange)="onFilesSelected($event)" #fileInput class="file-input-hidden" />

    <div class="dropzone-content">
      <div class="dropzone-icon">
        <mat-icon>cloud_upload</mat-icon>
      </div>

      <h3 class="dropzone-title">
        {{'components.attachment.file-attachment.drag-files-here' | translate}}
      </h3>

      <!-- <p class="dropzone-subtitle">
        {{ 'components.attachment.file-attachment.or-click-to-browse' | translate }}
      </p> -->

      <button mat-raised-button color="primary" type="button" class="browse-button" (click)="fileInput.click()">
        <mat-icon>folder_open</mat-icon>
        {{ 'components.attachment.file-attachment.browse-files' | translate }}
      </button>
    </div>
  </ngx-dropzone>

  <!-- Files list with upload progress -->
  @if (files.length > 0) {
  <div class="files-list">
    <div class="files-list-header">
      <h4>{{ 'components.attachment.file-attachment.selected-files' | translate }} ({{ files.length }})</h4>
      @if (files.length > 0 && !loading) {
      <button mat-button color="warn" (click)="removeAllFiles()">
        <mat-icon>delete_sweep</mat-icon>
        {{ 'components.attachment.file-attachment.clear-all' | translate }}
      </button>
      }
    </div>

    @for (f of files; track f.id) {
    <div class="file-item" [class.uploading]="f.uploading" [class.uploaded]="f.uploaded">
      <div class="file-icon">
        <mat-icon>{{ f.uploaded ? 'check_circle' : 'insert_drive_file' }}</mat-icon>
      </div>

      <div class="file-info">
        <div class="file-name">{{ f.name }}</div>

        @if (f.uploading || f.uploaded) {
        <div class="file-progress">
          <mat-progress-bar [mode]="f.uploading ? 'determinate' : 'determinate'" [value]="f.progress.data.percentage"
            [color]="f.uploaded ? 'accent' : 'primary'">
          </mat-progress-bar>
        </div>

        <div class="file-stats">
          <span class="progress-percentage">
            {{ f.progress.data.percentage }}%
            @if (f.uploading) {
            <span class="uploading-text">{{ 'generic.uploading' | translate }}</span>
            }
            @if (f.uploaded) {
            <span class="done-text">{{ 'generic.done' | translate }}</span>
            }
          </span>

          @if (f.uploading && f.progress.data.speedHuman && f.progress.data.etaHuman) {
          <span class="speed-eta">
            {{ f.progress.data.speedHuman }} • ETA {{ f.progress.data.etaHuman }}
          </span>
          }
        </div>
        }
      </div>

      <button mat-icon-button class="remove-button" [disabled]="f.uploading" (click)="cancelUpload(f.id)"
        [attr.aria-label]="'components.attachment.file-attachment.remove-file' | translate">
        <mat-icon>{{ f.uploading ? 'hourglass_empty' : 'close' }}</mat-icon>
      </button>
    </div>
    }
  </div>
  }
</div>